import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
} from "@material-ui/core";

import { setRotationType } from "../../../actions/app/creatives";
import { ROTATION_TYPES } from "../../../actions/app/constants";
import AssetWeight from "./AssetWeight";
import HelperTooltip from "../../Shared/HelperTooltip/HelperTooltip";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(2),
  },
  legend: {
    textAlign: "left",
  },
  helperText: {
    textAlign: "right",
    marginLeft: 32,
    marginTop: -6,
  },
  rotation: {
    width: "50%",
  },
}));

const AssetRotation = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const rotationType = useSelector((state) => state.creatives.rotationType);

  return (
    <div className={classes.rotation}>
      <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel component="legend" className={classes.legend}>
          Rotation Type
          <HelperTooltip tooltipText="When a creative set has multiple creatives, use rotation settings to determine which creative is delivered when your set serves." />
        </FormLabel>
        <RadioGroup
          aria-label="rotation"
          name="rotation"
          value={rotationType}
          onChange={(e) => dispatch(setRotationType(e.target.value))}
        >
          <FormControlLabel
            value={ROTATION_TYPES.WEIGHTED}
            control={<Radio />}
            label={
              <>
                Weighted
                <HelperTooltip tooltipText="Weighted rotation allows you to choose an evenly distributed weight or custom weight, rotated as a percentage of the overall campaign." />
              </>
            }
          />

          <FormControlLabel
            value={ROTATION_TYPES.CLICK_THROUGH_RATE}
            control={<Radio />}
            label={
              <>
                Click-through Rate
                <HelperTooltip tooltipText="In a rotation based on click-through rate, the creative with the highest click-through rate is served much more often than the other creatives." />
              </>
            }
          />
          <FormControlLabel
            value={ROTATION_TYPES.SEQUENTIAL}
            control={<Radio />}
            label={
              <>
                Sequential
                <HelperTooltip tooltipText="In a sequential rotation, the creatives are served to a user in the order you specify." />
              </>
            }
          />
          <FormHelperText className={classes.helperText}>
            Arrange creatives on left in order desired
          </FormHelperText>
        </RadioGroup>
      </FormControl>
      {rotationType === "WEIGHTED" ? <AssetWeight /> : null}
    </div>
  );
};

export default AssetRotation;
